// The Studio app's screens on the site: the /studio showcase (#studio-app). Real, raw app screens (the store
// renders' caption bands and device art cropped off; the site draws its own Mac and iPhone), as WebP in
// src/assets/studio-app, with the fictional "Northline Race Photo" workspace.
//
// SOURCE: the Studio app's App Store renders (photohawk-uploader test/store/store_screenshots_test.dart, en-US):
//   mac-01-live.png (2880×1800): the window's content below its title bar, 2160×1341, as 1080 / 2160 w;
//   iphone69-04-today.png (1320×2868): the screen inside the phone, with its status bar, 938×2049, as 320 / 640 w.
// To swap: crop the new renders the same way, replace the files below, and keep `width`/`height` the crop's size.

import macLive1080 from "@/assets/studio-app/mac-live-capture-1080.webp";
import macLive2160 from "@/assets/studio-app/mac-live-capture-2160.webp";
import phoneToday320 from "@/assets/studio-app/iphone-today-320.webp";
import phoneToday640 from "@/assets/studio-app/iphone-today-640.webp";

export interface StudioShot {
  src: string;
  srcSet: string;
  width: number;
  height: number;
}

export const STUDIO_APP_SHOTS = {
  /** The Mac window: Live capture, four cameras (Canon, Nikon, Sony, Fujifilm) sending to Riverside 10K › Finish. */
  mac: { src: macLive1080, srcSet: `${macLive1080} 1080w, ${macLive2160} 2160w`, width: 2160, height: 1341 },
  /** The iPhone: Today (sales, orders, photos delivered, galleries). */
  phone: { src: phoneToday320, srcSet: `${phoneToday320} 320w, ${phoneToday640} 640w`, width: 938, height: 2049 },
} satisfies Record<string, StudioShot>;
